import { useParams } from '@tanstack/react-router'
import { ConversationView } from './ConversationPage'

export function AssistantPage() {
  const params = useParams({ strict: false }) as { conversationId?: string }
  const conversationId = params.conversationId ?? null

  return <ConversationView conversationId={conversationId} />
}
